import React, { useState, useEffect } from 'react'

import cx from 'classnames'
import Styles from './PresenceCursor.module.scss'

// If you add anything in COLORS, don't forget to add the related
// styles in PresenceCursor.module.scss
const COLORS = ['green', 'blue', 'purple', 'orange', 'red', 'pink']

const TIME_NAME_REMAINS_AFTER_UNHOVER = 1000

export const nextColor = (attributedColors: string[]) => {
  if (attributedColors.length === 0) return COLORS[0]

  const notAttributed = COLORS.filter((color) => !attributedColors.includes(color))
  if (notAttributed.length > 0) return notAttributed[0]

  const tallies = COLORS.map((color) => attributedColors.filter((c) => c === color).length)
  return COLORS[tallies.indexOf(Math.min(...tallies))]
}

export const getSelectionClass = (color: string | undefined = COLORS[0]) => {
  return Styles[`background-color-transparent-${color}`]
}

export const getBorderClass = (color: string) => {
  return Styles[`border-color-${color}`]
}

export const getBackground50Class = (color: string) => {
  return Styles[`background-color-${color}-50`]
}

export const PresenceCursor = ({ color = COLORS[0], name }: { color: string | undefined; name: string }) => {
  const [isHovering, setIsHovering] = useState(false)
  const [showName, setShowName] = useState(false)

  useEffect(() => {
    if (isHovering) {
      setShowName(true)
    }

    const timer = setTimeout(() => {
      !isHovering && setShowName(false)
    }, TIME_NAME_REMAINS_AFTER_UNHOVER)

    return () => clearTimeout(timer)
  }, [isHovering])

  return (
    <span
      onMouseEnter={() => setIsHovering(true)}
      onMouseLeave={() => setIsHovering(false)}
      className={cx(Styles.cursorContainer, Styles[`cursor-color-${color}`])}
    >
      <div
        className={cx(Styles.userName, {
          [Styles.visible]: showName,
          [Styles.invisible]: !showName,
        })}
      >
        {name}
      </div>
      <div
        onMouseEnter={() => setIsHovering(true)}
        onMouseLeave={() => setIsHovering(false)}
        className={cx(Styles.cursorTop, {
          [Styles.visible]: !showName,
          [Styles.invisible]: showName,
        })}
      ></div>
    </span>
  )
}
